import PropTypes from 'prop-types';
import { useCallback } from 'react';

export default function ChannelTableRowRenderer({ item: channelItem, enableAdminOverride = false, handleItemClicked }) {
  const { creatorName, token, name, id } = channelItem;

  const onClick = useCallback(() => handleItemClicked(channelItem), [handleItemClicked, channelItem]);

  return (
    <tr key={`channel_${id}`} className="body-row">
      <td className="body-row-name">
        {enableAdminOverride && handleItemClicked ? (
          <>
            <button type="button" className="body-row-name-link btn text" onClick={onClick}>
              {name}
            </button>
          </>
        ) : (
          <span>{name}</span>
        )}
      </td>
      <td className="channel-token">{token}</td>
      <td className="channel-creator">{creatorName}</td>
    </tr>
  );
}

ChannelTableRowRenderer.propTypes = {
  handleItemClicked: PropTypes.func,
  enableAdminOverride: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    creatorName: PropTypes.string.isRequired,
  }).isRequired,
};

ChannelTableRowRenderer.defaultProps = {
  handleItemClicked: () => true,
  enableAdminOverride: false,
};
